export const constants = {
    isTouch:
        'ontouchstart' in window
            ? (function () {
                document.body.classList.add('touch');
                return true;
            })()
            : (function () {
                document.body.classList.add('no-touch');
                return false;
            })(),
    body: $('body'),
};

export function navFunction() {
    let body = $('body');
    let mainNav = $('.main-nav');
    let btnMenu = $('.btn-menu');
    let menuOverlay = $('.btn-menu');
    let btnBack = $('.btn-back');
    let cityDropdown = $('.city-dropdown');

    if ($(window).innerWidth() < 768) {
        var cityMenu = $('#menu-city-menu').html();
        $('.main-nav').prepend(
            '<li class="menu-item menu-item-object-page city-menu menu-item-has-children">' +
            '<a href="#">' +
            $('#selected-city-text').text() +
            '</a>' +
            '<div class="dropdown-menu">' +
            '<ul class="sub-menu">' +
            '' +
            cityMenu +
            '' +
            '</ul>' +
            '</div>' +
            '</li>'
        );
        $('.main-nav').append(
            '<li class="menu-item live-chat">' +
            '<a href="javascript:;" class="activate-zendesk">Live Chat</a>' +
            '</li>'
        );
    }

    $('.menu-overlay').on('click', function () {
        $('.header, .menu').removeClass('opened');
        $('body').removeClass('no-scroll').removeClass('overlay');
        btnMenu.removeClass('opened');
        $('.dropdown-menu').slideUp();
        $('.header-right').slideToggle();
    });

    btnMenu.on('click', function (e) {
        if ($(window).innerWidth() < 768) {
            $(this).toggleClass('opened');
            if (!$(this).hasClass('opened')) {
                btnBack.hide();
            }
            mainNav.find('> li').show();
            $('.dropdown-menu').hide();
            $('body').toggleClass('no-scroll');
            $('body').toggleClass('overlay');
            $('.header, .menu').toggleClass('opened');
            $('.header-right').slideToggle();
            e.preventDefault();
        }
    });

    btnBack.on('click', function (e) {
        if ($(window).innerWidth() < 768) {
            $(this).hide();
            mainNav.find('> li').slideDown();
            $('.dropdown-menu').slideUp();
            e.preventDefault();
        }
    });

    mainNav.find('.menu-item-has-children > a').on('click', function (e) {
        let $this = $(this);
        if ($(window).innerWidth() < 768) {
            e.preventDefault();
            $this.parent().toggleClass('active');
            $this.parent().find('.dropdown-menu').slideToggle();
        }
    });

    cityDropdown.find('.selected').on('click', function () {
        if (body.hasClass('touch')) {
            $(this).toggleClass('opened');
            $(this).parent().find('ul').slideToggle();
            $(body).toggleClass('overlay');
        }
    });

    /*$('.header').hover(
        function (e) {
            if (body.hasClass('no-touch')) {
                $('.menu-item-has-children').removeClass('hovered');
                if ($(e.target)[0].className === 'menu-item-has-children') {
                    $(e.target).addClass('hovered');
                    //body.addClass('overlay');
                }
            }
        },
        function () {
            $('.menu-item-has-children').removeClass('hovered');
            //body.removeClass('overlay');
        }
    );*/

    mainNav.find('> li').mouseover(function () {
        if ($(window).innerWidth() > 768) {
            $(this).addClass('hovered').siblings().removeClass('hovered');

            if ($(this).hasClass('menu-item-has-children')) {
                $(this).find('.dropdown-menu').show();
            }
        }
    });

    /*mainNav.find('> li:not(:first-child)').mouseleave(function () {
        $(this).removeClass('hovered').siblings().removeClass('hovered');
    });*/

    mainNav.find('> li').on('touchstart', function () {
        $(this).addClass('hovered').siblings().removeClass('hovered');
        body.removeClass('overlay');
        if ($(this).hasClass('menu-item-has-children')) {
            body.addClass('overlay');
        }
    });

    /*$(document).on('click', function (e) {
        console.log("-> e", e);
        let $target = $(e.target);
        if (!$target.closest('.header').length) {

            if ($(window).innerWidth() < 768) {
                $('.header-right').slideUp();
                btnMenu.removeClass('opened');
                $('.city-dropdown .selected').removeClass('opened');
                $('#menu-city-menu').slideUp();

                body.removeClass('overlay');
                $('.dropdown-menu').slideUp();
                $('.menu-item-has-children').removeClass('hovered');
            }
        }
    });*/
    /*$('html').on('touchstart', function (e) {
        console.log("-> touchstart", 'touchstart');
        let $target = $(e.target);
        if (!$target.closest('.header').length) {

            if ($(window).innerWidth() < 768) {
                $('.header-right').slideUp();
                btnMenu.removeClass('opened');
                $('.city-dropdown .selected').removeClass('opened');
                $('#menu-city-menu').slideUp();
            } else {
                body.removeClass('overlay');
                $('.dropdown-menu').slideUp();
                $('.menu-item-has-children').removeClass('hovered');
            }
        }
    });*/

    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    // Set top body padding according to the header height
    /* const headerHeight = 96;
     const announcementbarHeight = $('.announcement-bar').length ? 40 : 0;
     const activeDropdownMenu = $('.main-nav > li:first-child > .dropdown-menu');
     const activeDropdownMenuHeight = activeDropdownMenu.length ? 58 : 0;
     const adminBar = $(body).hasClass('admin-bar') ? 32 : 0;
     const topPadding = headerHeight + announcementbarHeight + activeDropdownMenuHeight + adminBar;
 
     if ($(window).innerWidth() > 768) {
         $('body').css('padding-top', topPadding );
     } else {
         $('body').css('padding-top', announcementbarHeight + 70 );
     }
     */
    // Activate the first sub menu in the navigation
    mainNav.find('> li').first().addClass('hovered');
}

export function stickyHeader() {
    let $header = $('.header.home');
    let top = $(document).scrollTop();
    if (top > 100) {
        $header.addClass('sticky');
    } else {
        $header.removeClass('sticky');
    }
}

export function footerMenu() {
    $('.footer-menu.mobile .menu-block h6').click(function () {
        var active = $(this).hasClass('active');
        $('.footer-menu.mobile .menu-block h6').each(function () {
            $(this).parent().removeClass('active');
            $(this).removeClass('active');
        });
        if (!active) {
            $(this).parent().addClass('active');
            $(this).addClass('active');
        }
    });
}

function afterLoad(instance) {
    // console.log('afterLoad', instance);
    if (instance.current.type == 'iframe') {
        var elem = document.querySelector('.fancybox-button--close');
        elem.style.float = 'right';
        var fancy = document.querySelector('.fancybox-content');
        fancy.appendChild(elem);
    }
}

function beforeLoad(instance) {
    // console.log('beforeLoad', instance);
    if (instance.current.type == 'iframe') {
        instance.current.opts.iframe.attr.referrerpolicy = 'origin';
        instance.current.opts.iframe.attr.allow = 'attribution-reporting; conversion-measurement';
    }
}

export function fancyButtonFix() {
    $('[data-fancybox]').fancybox({
        afterLoad: afterLoad,
        beforeLoad: beforeLoad,
    });
}

/*
window.fetchFancyboxJs = function() {
    console.log('initFancybox');
    ['click','ontouchstart','mousemove'].forEach( function(evt) {
        window.removeEventListener(evt, fetchFancyboxJs, false);
    });
    if ($('[data-fancybox]').length) {
        $.ajaxSetup({cache: true});
        $.getScript('/wp-content/themes/unlimitedbiking/js/libs/jquery.fancybox.min.js');
        $.ajaxSetup({cache: false});
    }
};

['click','ontouchstart','mousemove'].forEach( function(evt) {
    window.addEventListener(evt, fetchFancyboxJs, false);
});
*/


window.addEventListener('scroll', () => {
    stickyHeader();
});

window.addEventListener('load', function () {
    $('body').addClass('loaded');
});

function isValidUrl(urlString) {
    try {
        return Boolean(new URL(urlString));
    }
    catch (e) {
        return false;
    }
}

window.addEventListener(
    "message",
    (event) => {
        if (event.origin.includes("unlimitedbiking")) {
            let url = event.origin + event.data;
            if (isValidUrl(url)) {
                // $.fancybox.open({ type: 'iframe', src: url, afterLoad: afterLoad });
                location.href = url;
            }
        };
    },
    false,
);


// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/module.js